import React from 'react';

const ImageAttributtion = ({ attribution } = {}) => (
    <div className="split-container__attribution eds-text-bs eds-text-color--white eds-text--right">
        <div className="split-container__attribution-first-row">
            {attribution.firstRow}
        </div>
        <div className="split-container__attribution-second-row">
            {attribution.secondRow}
        </div>
        <div className="split-container__attribution-third-row">
            {attribution.thirdRow}
        </div>
    </div>
);

export default ImageAttributtion;
